import moment from 'moment';
import 'moment/locale/es';

export const dateTimeFormat = (date) => {
    return moment(date).format('DD [de] MMMM');
};


export const dateFormat = (date) => {
    return moment(date).format('DD/MM/YYYY');
};



// WEBPACK FOOTER //
// ./src/utils/formatters.js